import {getAreaList, getIndustryList, getPositionList, getRefTable} from '@/request'
import storage from '@/shared/storage'
import {frozenPromise} from '@/shared/untils'
import {Common} from '@/interface/common.interface'

const experienceOptions = ['1-3年', '3-5年', '5-10年', '10-15年', '15年以上']
const educationOptions = ['专科及以下', '本科', '硕士', '博士']
const gradeOptions = [
  '一年级',
  '二年级',
  '三年级',
  '四年级',
  '五年级',
  '六年级',
  '七年级',
  '八年级',
  '九年级',
  '高一',
  '高二',
  '高三',
]
const frozenGetPosition: Function = frozenPromise(getPositionList)
const frozenGetIndustry: Function = frozenPromise(getIndustryList)

class EnumModelContainer {
  /**
   * @method getExperienceList
   * 返回工作经验列表：
   * ['1年以下', '1-3年', '3-5年', '5年以上']
   */
  getExperienceList() {
    return experienceOptions
  }

  /**
   * @method getEducationList
   * 返回教育经历列表：
   * ['高中以下', '大专', '本科', '硕士', '博士']
   */
  getEducationList() {
    return educationOptions
  }

  /**
   * @method gradeOptions
   * 返回年级列表：
   * ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '七年级', '八年级', '九年级']
   */
  getGradeList() {
    return gradeOptions
  }

  /**
   * @method getAreaList
   * 返回地区树的信息
   */
  async getAreaList() {
    // 有，直接返回
    const areaList = storage.get('areaList')
    if (areaList) return areaList

    // 没有，请求了再返回
    const {provinces} = await getAreaList()
    // 转换数据结构
    this.changePropsName(provinces as Common.AreaResult[])
    storage.set('areaList', provinces)
    return provinces
  }

  /**
   * @description: 查询码表配置
   * @method getRefTable
   * @return 返回码表配置
   */
  async getRefTable() {
    const result = await getRefTable({
      tblKeys: [
        'enroll_category',
        'enroll_mode',
        'sch_type',
        'sch_run_type',
        'sch_type_tag',
        'enroll_language',
        'nationality',
        'problem_area',
        'usage_scenario',
        'sticker_group',
        'channel_source',
        'major_special_policy_tags',
        'nationality_limit',
        'physical_limit',
        "suitable_crowd"
      ],
    })
    result.tblRecords.forEach((tbl: Common.Tbl) => {
      storage.set(`tbl_${tbl.tblName}`, tbl.refTblRecords, false)
    })
    return result
  }

  /**
   * @method getAreaList
   * 返回职业信息列表
   */
  async getPositionList() {
    const {list} = await frozenGetPosition()
    return list.reduce((obj: any, item: any) => {
      obj[item.positionId] = item.name
      return obj
    }, {})
  }

  /**
   * @method getIndustryList
   * 返回行业信息列表
   */
  async getIndustryList() {
    const {list} = await frozenGetIndustry()
    return list
  }

  private changePropsName(list: Record<string, any>) {
    for (let i = 0, len = list.length; i < len; i++) {
      const item = list[i]
      const children = item.citys || item.districts
      if (!children) break
      item.children = children
      if (item.citys) delete item.citys
      if (item.districts) delete item.districts
      this.changePropsName(item.children)
    }
  }
}

export default new EnumModelContainer()
